import React, { useMemo, useRef } from 'react';
import CommonBubble from '@home/components/CommonBubble';
import useIsTextOverflow from '@/pages/aigc/components/EllipsisHover/_hooks/useIsTextOverflow';
import '@/pages/aigc/components/EllipsisHover/index.scss';
import type { TFileSourceSkillItem } from '../../utils';

/**
 * Skill 来源列：整行总宽度省略，溢出时 hover 气泡逐行展示
 * @param props.items - 已解析的 Skill 来源项
 */
const SkillSourceCell: React.FC<{ items: TFileSourceSkillItem[]; }> = ({
  items,
}) => {
  const wrapperRef = useRef<HTMLSpanElement>(null);
  const text = useMemo(
    () => items.map(item => item.label).join(', '),
    [items],
  );
  const isOverflow = useIsTextOverflow(wrapperRef, { text });

  const bubbleContent = (
    <div className="dba-file-library__source-popover">
      {items.map((item, index) => (
        <span
          key={`${item.label}-${index}`}
          className="dba-file-library__source-skill-item dba-file-library__source-skill-item--popover"
        >
          <img src={item.icon} alt="" />
          <span>{item.label}</span>
        </span>
      ))}
    </div>
  );

  return (
    <CommonBubble
      dark
      arrowPointAtCenter
      placement="top"
      overlayClassName="dba-file-library__source-bubble"
      content={isOverflow ? bubbleContent : undefined}
    >
      <div className="dba-ellipsis-hover dba-file-library__source-skill-wrap">
        <span ref={wrapperRef} className="dba-ellipsis-hover__text-wrapper">
          <span className="dba-file-library__source-skill-row">
            {items.map((item, index) => (
              <span
                key={`${item.label}-${index}`}
                className="dba-file-library__source-skill-item"
              >
                <img src={item.icon} alt="" />
                <span>{item.label}</span>
              </span>
            ))}
          </span>
        </span>
      </div>
    </CommonBubble>
  );
};

export default SkillSourceCell;
